module.exports = __webpack_public_path__ + "img/filtro-icon.59e6ca95.svg";